import React from 'react';

export const HotelsContext = React.createContext({});
